export default function ScheduleArticleSkeleton() {
  return (
    <div className='mb-2 w-full overflow-x-auto lg:w-2/3 lg:p-3'>
      <div>
        <div className='inline-flex h-10 w-full flex-nowrap border-x bg-gray-900 font-semibold text-white rounded-t-lg'>
          <div className='self-center p-3 text-sm font-bold tracking-wide bg-gray-700 animate-pulse rounded w-1/3 ml-2' />
        </div>

        <div className='border-lg flex w-full flex-col gap-2 border-x border-b p-2'>
          <div className='flex items-center'>
            <div className='flex-1'>
              {[...Array(2)].map((_, i) => (
                <article className='rounded-lg border-b bg-white shadow-md lg:p-0' key={i}>
                  <div className='flex w-full justify-between rounded-t-lg bg-gray-100 p-1 lg:hidden'>
                    <div className='h-6 w-1/2 animate-pulse rounded bg-gray-300' />
                  </div>

                  <div className='flex flex-col-reverse items-center p-2 sm:flex-row sm:gap-8'>
                    <div className='hidden h-36 w-48 flex-col items-center justify-between rounded-l-lg bg-gray-200 p-6 lg:flex'>
                      <div className='h-4 w-6 animate-pulse rounded bg-gray-300' />
                      <div className='h-6 w-12 animate-pulse rounded bg-gray-300' />
                      <div className='h-4 w-12 animate-pulse rounded bg-gray-300' />
                    </div>

                    <div className='w-full'>
                      <div className='flex justify-between'>
                        <div className='h-6 w-1/3 animate-pulse rounded bg-gray-300' />
                      </div>
                      <div className='mt-2 flex flex-col sm:gap-2'>
                        <div className='mt-1 h-4 w-1/2 animate-pulse rounded bg-gray-300' />
                        <div className='mt-2 h-3 w-1/3 animate-pulse rounded bg-gray-200 sm:mt-0' />
                        <div className='my-2 h-8 w-1/2 animate-pulse rounded-full bg-gray-200 lg:w-1/3' />
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
